<template>
  <div id="app">
    <router-view></router-view>
    <div class="footer">
      <router-link to="/home">
        <img src="@/assets/images/f1-1.png" alt="">
        <p style="color: black;">首页</p>
      </router-link>
      <router-link to="/kj">
        <img src="@/assets/images/fz.png" alt="">
        <p style="color: black;">矿机</p>

      </router-link>
      <!-- <router-link to="/cycswap" >
                        <img src="@/assets/images/us3.png" alt="">
                        <p>swap</p>
                    </router-link>
                    <router-link to="/kline" >
                        <img src="@/assets/images/f2-1.png" alt="">
                        <p>K綫圖</p>
                    </router-link> -->
      <router-link to="/user">
        <img src="@/assets/images/f3-1.png" alt="">
        <p style="color: black;">个人</p>
      </router-link>
    </div>
  </div>
</template>

<script>


export default {
  name: 'App',

}
</script>

<style scoped>
.footer {
  width: 100%;
}
</style>
